import { css } from '@emotion/css';

export const textareaStyles = (size = 0) => css`
  .MuiInputBase-input {
    min-height: ${size}rem;
  }
`;
